import { Injectable } from '@angular/core';
import { AppNotification } from './app/shared/services/notification.service';
import { environment } from './environments/environment';

@Injectable()
export class Config {
  readonly login = environment.loginConfig;

  readonly setPassword = {
    action: '/api/public/setUserPassword',
    method: 'POST',
  };

  readonly resetPassword = {
    action: '/api/public/resetUserPassword',
    method: 'POST',
  };

  readonly createProfile = {
    action: '/api/public/createProfile',
    method: 'POST',
  };

  // TODO: rename the property and fix content if needed when BE is ready
  readonly updatePassword = {
    action: '/api/public/updateUserPassword',
    method: 'POST',
  };

  readonly passwordBanCheckUrl = '/auth/api/public/passwordBanCheck';
}

export const loginErrorNotification: AppNotification = {
  message: 'Email address or password is incorrect.',
  type: 'error',
};
export const logoutSuccessNotification: AppNotification = {
  message: 'You have been logged out successfully.',
  type: 'success',
};
export const incorrectEmailOrCodeNotification: AppNotification = {
  message: 'Email address or code is incorrect.',
  type: 'error',
};
